import React, { Component } from "react";
import db from "../../api/db";
import moment from "moment";
import classNames from "classnames";
import axios from "axios";
import "moment/locale/nb";

class Jobs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      job: [],
      refreshset: false
    };
  }

  boot = () => this.bootIndex();

  componentDidMount() {
    this.setAutoReload();
    this.searchQuery();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  bootIndex() {
    var url = "/api/operations/bootindex/";

    axios({
      method: "post",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json"
      },
      url: url + "366"
    })
      .then(response => {
        this.searchQuery();
      })
      .catch(err => {
        console.log(err);
      });
  }

  bootSingle(id) {
    axios({
      method: "post",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json"
      },
      url: "/api/operations/initjob/",
      data: {
        id: id
      }
    })
      .then(response => {
        this.searchQuery();
      })
      .catch(err => {
        console.log(err);
      });
  }

  setAutoReload() {
    this.interval = setInterval(() => this.searchQuery(), 3000);
  }

  searchQuery() {
    db.query("job", {})
      .then(response => {
        this.setState({
          job: response.data
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  getJobVariables(job) {
    let done = 0;
    let persons = 0;
    let timeperson = 0;
    let withtime = 0;
    let personleft = 0;
    for (var i = job.length - 1; i >= 0; i--) {
      var endtime = job[i].endtime
        ? job[i].endtime
        : Math.round(moment().format("x") / 1000);

      if (job[i].done) {
        done++;
      } else if (job[i].persons) {
        personleft += job[i].persons;
      }
      if (job[i].persons) {
        persons += job[i].persons;
        if (endtime && job[i].starttime) {
          timeperson =
            timeperson + (endtime - job[i].starttime) / job[i].persons;
          withtime++;
        }
      }
    }
    const totcount = Intl.NumberFormat().format(persons);
    const timeleft =
      withtime && personleft ? (timeperson / withtime) * personleft : 0;

    return {
      done: done,
      personcount: totcount,
      finished: timeleft
        ? moment().add(timeleft, "seconds").format("D/M HH:mm")
        : null
    };
  }

  duration(starttime, endtime) {
    let end;
    if (!starttime) return null;
    if (!endtime) {
      end = parseInt(moment().format("X"));
    } else {
      end = endtime;
    }
    return moment.duration(end - starttime, "seconds").humanize();
  }

  lastRun(last) {
    const lastRunDate = moment(last).format("DD.MM YYYY");
    const timeSinceLastRun = moment
      .duration(moment().diff(last, "seconds") * -1, "seconds")
      .humanize(true);

    return `${lastRunDate} (${timeSinceLastRun})`;
  }

  render() {
    const vars = this.getJobVariables(this.state.job);

    return (
      <div className="main-container">
        <div className="grid-x">
          <div className="medium-9 cell">
            <div className="primary-content">
              <div className="inner">
                <div className="grid-x">
                  <button onClick={this.boot} className="button red">
                    Indekser alle personer
                  </button>
                </div>
                <h3>Dager</h3>
                <div>
                  {this.state.job.length
                    ? Math.round(vars.done * (100 / this.state.job.length))
                    : 0}
                  % Indeksert. Totalt {vars.personcount} personer i basen
                </div>
                {vars.finished ? (
                  <div>Estimert ferdig: {vars.finished}</div>
                ) : null}
                <table>
                  <thead>
                    <tr>
                      <th>Dag</th>
                      <th>Sist kjørt</th>
                      <th>Tid brukt</th>
                      <th>Personer</th>
                      <th>Fremgang</th>
                      <th>Gjort</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.job.map((item, i) => (
                      <React.Fragment key={item.id}>
                        <tr className="spacer" />
                        <tr
                          className={classNames("jobrow", {
                            odd: i % 2,
                            warning: !item.done,
                            progress: item.inprogress
                          })}
                        >
                          <td>
                            {`${parseInt(item.day)}. ${moment(
                              item.month,
                              "MM"
                            ).format("MMMM")}`}
                          </td>
                          <td>{this.lastRun(item.last)}</td>
                          <td>{this.duration(item.starttime, item.endtime)}</td>
                          <td>{item.persons}</td>
                          <td>{`${item.progress}%`}</td>
                          <td>{item.done ? "Ja" : "Nei"}</td>
                          <td>
                            <button
                              className={classNames("button small", {
                                red: item.inprogress
                              })}
                              disabled={!item.done && !item.inprogress}
                              onClick={() => this.bootSingle(item.id)}
                            >
                              {item.inprogress
                                ? "Restart"
                                : !item.done
                                ? "I kø"
                                : "Indekser"}
                            </button>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="medium-3 cell">
            <div className="sidebar-holder"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Jobs;
